import { Stack, Typography } from "@mui/material";

interface DetailFieldProps {
  field: string;
  value?: string | boolean | string[] | null;
}

// "hostName" → "Host Name"; labels that already contain spaces pass through.
const humanize = (field: string) => {
  if (field === "id") return "ID";
  if (field.includes(" ")) return field;
  return field
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
};

export const DetailField = ({ field, value }: DetailFieldProps) => {
  return (
    <Stack gap={0.25} key={field}>
      <Typography variant="subtitle2" color="text.secondary">
        {humanize(field)}
      </Typography>
      <Typography
        variant="body1"
        sx={{ wordBreak: "break-word", ...(!value && { color: "red" }) }}
      >
        {value ? value?.toString() : "Not found"}
      </Typography>
    </Stack>
  );
};
